/*
 * Chapter navigator (mobile) — porta il capitolo CORRENTE come primo elemento a sinistra.
 *
 * Su mobile la barra .main-index--chapter è una riga scrollabile in orizzontale; di default
 * partirebbe da inizio menu (capitolo I). Il cambio capitolo è una navigazione full-page,
 * quindi a ogni capitolo la pagina ricarica: qui posizioniamo
 * la barra sul capitolo PRECEDENTE e la facciamo scorrere di uno fino al CORRENTE → effetto
 * "avanza di uno", con il capitolo attivo sempre come primo numero a sinistra.
 *
 * Scoped al mobile in modo robusto: agisce solo se la barra è effettivamente scrollabile in
 * orizzontale; su desktop (grid statica) è un no-op. Rispetta prefers-reduced-motion.
 */
(function () {
  'use strict';

  if (typeof document === 'undefined') return;

  function place() {
    var bar = document.querySelector('.main-index--chapter');
    if (!bar) return;
    // Non scrollabile (desktop / barra che ci sta tutta) → niente da fare.
    if (bar.scrollWidth <= bar.clientWidth + 1) return;

    var current = bar.querySelector('.main-index__item--current');
    if (!current) return;

    var target = current.offsetLeft;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var prev = current.previousElementSibling;

    // Reduced-motion o primo capitolo (nessun precedente): posiziona il corrente a sinistra senza animazione.
    if (reduce || !prev) {
      bar.scrollLeft = target;
      return;
    }

    // Parti col precedente a sinistra, poi scorri di uno fino al corrente.
    bar.scrollLeft = prev.offsetLeft;
    requestAnimationFrame(function () {
      bar.scrollTo({ left: target, behavior: 'smooth' });
    });
  }

  // Init non visual-critical: differito a idle (convenzione MadeInEvolve).
  var idle = typeof requestIdleCallback === 'function' ? requestIdleCallback : setTimeout;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { idle(place); }, { once: true });
  } else {
    idle(place);
  }

  // Theme editor: la sezione header/index viene ricostruita.
  document.addEventListener('shopify:section:load', place);
})();
